import { toInteger } from 'lodash';
import React, { useEffect, useState } from 'react';
import { getLayerInnerStyle } from '@/utils/layer-kit';
import { ILayerProps, IMediaLayerProps, IRenderLayerEvent } from '@/version-types';

const MediaImage: React.FC<{ layer: ILayerProps; normalIcon?: boolean } & IRenderLayerEvent> = ({ layer }) => {
    const { opacity, width, height, id } = layer;
    const {
        url,
        poster,
        autoplay,
        loop,
        controls,
        muted = true,
        imageTransform: { widthRatio, heightRatio, flipH, flipV, offsetX: offsetXRatio, offsetY: offsetYRatio, scale },
    } = layer.data as IMediaLayerProps;
    const originImgWidth = toInteger(width * widthRatio);
    const originImgHeight = toInteger(height * heightRatio);
    const offsetX = toInteger(offsetXRatio * originImgWidth * scale);
    const offsetY = toInteger(offsetYRatio * originImgHeight * scale);
    const [videoUrl, setVideoUrl] = useState(url);
    const [posterUrl, setPosterUrl] = useState(poster);
    const innerStyle = getLayerInnerStyle(originImgWidth, originImgHeight, offsetX, offsetY, scale, flipH, flipV);
    useEffect(() => {
        setVideoUrl(url);
    }, [url]);
    useEffect(() => {
        setPosterUrl(poster);
    }, [poster]);

    return (
        <div
            style={{
                ...innerStyle,
                opacity,
            }}
        >
            <video
                src={videoUrl}
                autoPlay={autoplay}
                controls={controls}
                muted={muted}
                loop={loop}
                poster={posterUrl}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            ></video>
        </div>
    );
};
export default React.memo(MediaImage);
